import { JSX } from 'react'

import { IconProps } from '../../icon'

const Mic: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 48 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      d='M24.3305 29.7143C25.846 29.7143 27.2995 29.1122 28.3711 28.0406C29.4427 26.969 30.0448 25.5155 30.0448 24V13.7143C30.0448 12.1988 29.4427 10.7453 28.3711 9.67368C27.2995 8.60204 25.846 8 24.3305 8C22.815 8 21.3615 8.60204 20.2899 9.67368C19.2183 10.7453 18.6162 12.1988 18.6162 13.7143V24C18.6162 25.5155 19.2183 26.969 20.2899 28.0406C21.3615 29.1122 22.815 29.7143 24.3305 29.7143ZM20.9019 13.7143C20.9019 12.805 21.2631 11.9329 21.9061 11.2899C22.5491 10.6469 23.4212 10.2857 24.3305 10.2857C25.2398 10.2857 26.1119 10.6469 26.7549 11.2899C27.3978 11.9329 27.7591 12.805 27.7591 13.7143V24C27.7591 24.9093 27.3978 25.7814 26.7549 26.4244C26.1119 27.0673 25.2398 27.4286 24.3305 27.4286C23.4212 27.4286 22.5491 27.0673 21.9061 26.4244C21.2631 25.7814 20.9019 24.9093 20.9019 24V13.7143Z'
      fill='black'
    />
    <path
      d='M34.6161 22.7429C34.5858 22.4398 34.4364 22.1611 34.2006 21.9682C33.9648 21.7753 33.6621 21.684 33.359 21.7143C33.0559 21.7446 32.7772 21.8941 32.5844 22.1298C32.3915 22.3656 32.3001 22.6683 32.3304 22.9714C32.4397 24.1221 32.307 25.2828 31.9409 26.3791C31.5748 27.4755 30.9834 28.483 30.2047 29.3371C29.4721 30.1744 28.5689 30.8454 27.5558 31.3051C26.5427 31.7648 25.443 32.0026 24.3304 32.0026C23.2179 32.0026 22.1182 31.7648 21.1051 31.3051C20.0919 30.8454 19.1888 30.1744 18.4561 29.3371C17.6774 28.483 17.086 27.4755 16.7199 26.3791C16.3538 25.2828 16.2212 24.1221 16.3304 22.9714C16.3607 22.6683 16.2694 22.3656 16.0765 22.1298C15.8836 21.8941 15.605 21.7446 15.3019 21.7143C14.9988 21.684 14.696 21.7753 14.4603 21.9682C14.2245 22.1611 14.075 22.4398 14.0447 22.7429C13.9096 24.2101 14.0816 25.6895 14.5499 27.0865C15.0182 28.4836 15.7725 29.7678 16.7647 30.8571C18.427 32.7194 20.7098 33.9136 23.1876 34.2171C23.1876 34.2171 23.1876 34.2171 23.1876 34.2857V37.7143H19.759C19.4559 37.7143 19.1652 37.8347 18.9509 38.049C18.7366 38.2634 18.6161 38.554 18.6161 38.8571C18.6161 39.1603 18.7366 39.4509 18.9509 39.6653C19.1652 39.8796 19.4559 40 19.759 40H28.9019C29.205 40 29.4957 39.8796 29.71 39.6653C29.9243 39.4509 30.0447 39.1603 30.0447 38.8571C30.0447 38.554 29.9243 38.2634 29.71 38.049C29.4957 37.8347 29.205 37.7143 28.9019 37.7143H25.4733V34.2857C25.4733 34.2857 25.4733 34.2857 25.4733 34.2171C27.951 33.9136 30.2338 32.7194 31.8961 30.8571C32.8883 29.7678 33.6426 28.4836 34.1109 27.0865C34.5792 25.6895 34.7513 24.2101 34.6161 22.7429Z'
      fill='black'
    />
  </svg>
)

export default Mic
